import React from 'react';
import { Flame } from 'lucide-react';
import { useUserStreak } from '../hooks/api';
import { ResponsiveCard } from './ResponsiveContainer';

const StreakCounter = () => {
  const { data: streak, isLoading, isError } = useUserStreak();

  if (isLoading || isError) {
    return null;
  }

  const { current_streak, longest_streak, total_active_days } = streak || {};
  const hasStreak = current_streak > 0;

  const getMessage = () => {
    if (!hasStreak) return 'Log time today to start a streak!';
    if (current_streak === 1) return 'Great start! Keep it going.';
    if (current_streak < 5) return 'Keep it going!';
    if (current_streak < 10) return 'You\'re on fire!';
    return 'Incredible consistency!';
  };

  return (
    <ResponsiveCard className="flex flex-col justify-center" hover>
      <div className="flex items-center gap-3">
        <div
          className={`flex items-center justify-center w-12 h-12 rounded-xl ${
            hasStreak
              ? 'bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400'
              : 'bg-secondary-100 dark:bg-secondary-700 text-secondary-500 dark:text-secondary-400'
          }`}
        >
          <Flame className="h-6 w-6" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-secondary-600 dark:text-secondary-400">
            {hasStreak ? `${current_streak} day streak` : 'Streak'}
          </p>
          <p className="text-lg font-bold text-secondary-900 dark:text-white truncate">
            {hasStreak ? getMessage() : 'Start logging'}
          </p>
          {total_active_days > 0 && (
            <p className="text-xs text-secondary-500 dark:text-secondary-400 mt-0.5">
              Longest: {longest_streak} days · {total_active_days} active days total
            </p>
          )}
        </div>
      </div>
    </ResponsiveCard>
  );
};

export default StreakCounter;
